const fr= {
  username: "user name"
}
export default fr;



// WEBPACK FOOTER //
// ./src/language/fr.js